import { Component, OnInit, OnDestroy } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { BoobleModalService } from 'booble-modal';
import { Moedas } from 'src/app/domain/constants/moeda.constant';
import {
  InboundOrderDto,
  OrderAttachmentDto,
} from 'src/app/domain/models/dto/inbound-order.dto';
import { OrdersService } from 'src/app/shared/services/orders.service';
import { SettlementDocumentsComponent } from '../settlement-documents/settlement-documents.component';
import * as saveAs from 'file-saver';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-exchange-details',
  templateUrl: './exchange-details.component.html',
  styleUrls: ['./exchange-details.component.scss'],
})
export class ExchangeDetailsComponent implements OnInit, OnDestroy {
  boobleModalData: any;
  currency: any;
  moedas = Moedas;

  iof: number;
  ir: number;
  commercial: number;

  private readonly notifier: NotifierService;
  public loading: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(
    private modalService: BoobleModalService,
    private readonly ordersService: OrdersService,
    notifierService: NotifierService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit() {
    if (typeof this.boobleModalData === 'number') {
      this.loading = true;
      this.ordersService
        .getOrderById(this.boobleModalData, "true")
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (result) => {
            this.loading = false;
            this.boobleModalData = result.data;
            this.initializeComponent();
          },
          error: () => {
            this.loading = false;
          },
        });
    } else {
      this.initializeComponent();
    }
  }

  initializeComponent() {
    this.currency = this.moedas.find(
      (moeda) => moeda.id === this.boobleModalData?.currency?.id
    );

    if (this.boobleModalData?.quotations?.length > 0) {
      const quotation = this.boobleModalData.quotations[0];
      if (this.boobleModalData.remmitanceType === 'OUTBOUND') {
        this.ir = quotation.irOutbound;
        this.iof = quotation.iofOutbound;
        this.commercial = Number(
          (quotation.rate + quotation.rate * quotation.spread).toPrecision(5)
        );
      } else if (this.boobleModalData.remmitanceType === 'INBOUND') {
        this.ir = quotation.irInbound;
        this.iof = quotation.iofInboud;
        this.commercial = Number(
          (quotation.rate - quotation.rate * quotation.spread).toPrecision(5)
        );
      }
    }
  }

  increasePercentage(value: number, percentage: number) {
    return value + value * percentage;
  }

  downloadAttachment(orderAttachment: OrderAttachmentDto) {
    this.ordersService.downloadOrderAttachment(orderAttachment.id).subscribe({
      next: (data: any) => saveAs(data, orderAttachment.fileName),
    });
  }

  downloadAttachmentByName(fileName: string) {
    this.ordersService.downloadOrderAttachmentByName(fileName).subscribe({
      next: (data: any) => {
        saveAs(data, fileName);
        this.notifier.notify(
          'success',
          'Download do arquivo realizado com sucesso.'
        );
      },
      error: () => {
        this.notifier.notify('error', 'Erro ao efetuar o download do arquivo.');
      },
    });
  }

  getIr(rate: number, spread: number, taxIr: number, ptax: number) {
    const residualIr =
      ((this.increasePercentage(rate, spread) < ptax
        ? ptax
        : this.increasePercentage(rate, spread)) *
        this.boobleModalData.amount) /
      (1 - taxIr);
    return residualIr * taxIr;
  }

  getModalityText(modalityCode: number) {
    switch (modalityCode) {
      case 1:
        return 'À Vista';
      case 2:
        return 'Antecipado';
      case 3:
        return 'À Prazo';
      default:
        return '-';
    }
  }

  closeModal() {
    this.modalService.dismiss(null);
  }

  openSettlementDocumentsComponentModal(orderId: number) {
    this.modalService.present(SettlementDocumentsComponent, orderId);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
